import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function InvitationsTab() {
  const [inv, setInv] = useState([]);
  const [eng, setEng] = useState([]);
  const load = () => { api.get("/my/invitations").then((r) => setInv(r.data)).catch(() => setInv([])); api.get("/my/engagements").then((r) => setEng(r.data)).catch(() => setEng([])); };
  useEffect(() => { load(); }, []);
  const act = (i, a) => api.post(`/my/invitations/${i.invitation_id}/${a}`).then(() => { toast.success(a === "accept" ? "Shift accepted" : "Invitation declined"); load(); }).catch((e) => toast.error(e.response?.data?.detail || "Failed"));
  return (
    <div className="space-y-4">
      <div className="rounded-2xl border bg-white p-4 space-y-2" data-testid="my-invitations">
        <div className="font-semibold text-slate-700">Shift invitations</div>
        {inv.length === 0 && <p className="text-sm text-slate-400">No pending invitations.</p>}
        {inv.map((i) => (
          <div key={i.invitation_id} className="flex justify-between items-center text-sm border-t pt-2" data-testid={`my-invitation-${i.invitation_id}`}>
            <div><div className="font-medium">{i.org_name} · {i.date} {i.start}–{i.end}</div><div className="text-xs text-slate-500">{i.site_name} · {i.role || i.worker_type}</div></div>
            <div className="flex gap-2"><Button size="sm" onClick={() => act(i, "accept")} data-testid={`my-invitation-accept-${i.invitation_id}`}>Accept</Button>
              <Button size="sm" variant="outline" onClick={() => act(i, "decline")} data-testid={`my-invitation-decline-${i.invitation_id}`}>Decline</Button></div>
          </div>))}
      </div>
      <div className="rounded-2xl border bg-white p-4 space-y-3" data-testid="my-engagements">
        <div className="font-semibold text-slate-700">Engagements</div>
        {eng.length === 0 && <p className="text-sm text-slate-400">No engagements.</p>}
        {eng.map((e) => (
          <div key={e.engagement_id} className="border-t pt-2 text-sm" data-testid={`my-engagement-${e.engagement_id}`}>
            <div className="font-medium">{e.org_name} <span className="text-[10px] uppercase text-slate-400 ml-1">{e.phase.replace("_", " ")}</span></div>
            {e.briefing && <div className="text-xs text-slate-600 mt-1 space-y-0.5">
              {(e.sites || []).map((s) => <div key={s.name}>{s.name}{s.address ? ` — ${s.address}` : ""}</div>)}
              {Object.entries(e.briefing).filter(([, v]) => v).map(([k, v]) => <div key={k}><span className="capitalize text-slate-400">{k.replace("_", " ")}:</span> {v}</div>)}
              {(e.upcoming_shifts || []).map((s, n) => <div key={n}>{s.date} {s.start}–{s.end} {s.role ? `· ${s.role}` : ""}</div>)}
            </div>}
          </div>))}
      </div>
    </div>
  );
}
